<template>
  <label
    class="amw-radio-wrap radio-label focus disBl"
    :class="{ NCAcmi_radio_off: disabled }"
    :style="{ cursor: disabled ? 'default' : 'pointer' }"
  >
    <input
      type="radio"
      class="amw-global-radio"
      :name="`activity-radio-${unique}`"
      :value="example.se_code"
      @change="selectActivity"
      :checked="checked"
      :disabled="disabled"
    />
    <span class="amw-radio-overlay"></span>
    <span class="amw-label-radio-text">
      {{ displayText }} <em v-if="example.remain_num !== null">(잔여 {{ example.remain_num }})</em>
    </span>
  </label>
</template>

<script>
import { SURVEY_SINGAPORE, GET_DATA_IDX_BY_TYPE, SELECT_SCHEDULE_DATA } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SurveyReturnScheduleExample',
  props: {
    examples: {
      type: Array,
      required: true
    },
    example: {
      type: Object,
      required: true
    },
    attendant: {
      type: Object,
      required: true
    },
    unique: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(SURVEY_SINGAPORE, {
      originals: state => state.originals,
    }),
    ...mapGetters(SURVEY_SINGAPORE, {
      getDataIdx: GET_DATA_IDX_BY_TYPE,
    }),
    // 일반 액티비티 key값
    normalExampleKeys() {
      return this.examples.map(example => example.se_code);
    },
    responseIdx() {
      return this.getDataIdx(this.attendant.type, this.attendant.type_seq);
    },
    // 15세 미만 불가능(마사지 액티비티만)
    unavailable() {
      if(!this.isMassageActivity) return false;

      const age = this.getAge(this.birthYear, this.reference);
      return age < 15;
    },
    choices() {
      return this.attendant.questions[this.example.sq_code];
    },
    choice() {      
      return this.choices.find(choice => !choice.se_code || this.normalExampleKeys.includes(choice.se_code));
    },
    displayText() {
      return this.example.display_text;
    },
    checked() {
      return this.choice.se_code === this.example.se_code;
    },
    disabled() {
      return this.unavailable || (this.example.se_code !== this.prevSelectedExample && this.example.remain_num === 0);
    },
    // 이전에 선택했던 액티비티
    prevSelectedExample() {
      if(this.originals) {
        const originalResponse = this.originals[this.responseIdx];
        if(originalResponse && originalResponse.questions && originalResponse.questions[this.example.sq_code]) {
          const prevExample = originalResponse.questions[this.example.sq_code].find(choice => this.normalExampleKeys.includes(choice.se_code));
          if(prevExample) {
            return prevExample.se_code;
          }
        }
      }
      return null;
    },
  },
  methods: {
    selectActivity() {
      this.$store.dispatch(`${SURVEY_SINGAPORE}/${SELECT_SCHEDULE_DATA}`, {
        idx: this.responseIdx,
        sq_code: this.example.sq_code,
        se_code: this.example.se_code,
        se_data: null,
        remarks: null
      });
    },
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyReturnScheduleExample.vue